import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { useLocaleNavigate } from "@ct-react/locale";
import { actions } from "../../i18n/sharable-defs";
import { Wrapper } from "../layout/wrapper";
import Button from "../common/button";
import RatioImage from "../medias/ratio-image";
import aboutPath from "../../assets/home/about.jpg";
import "./about.scss";

const transDefs = defineMessages({
  kicker: { id: "homepage.about.kicker", defaultMessage: "À propos" },
  title: { id: "homepage.about.title", defaultMessage: "Votre projet immobilier,\nnotre priorité" },
  p1: {
    id: "homepage.about.p1",
    defaultMessage:
      "Bienvenue chez EV Real Estate & Services, votre agence immobilière locale et indépendante au cœur des 4 Vallées. Basée à Haute-Nendaz, nous mettons à votre disposition une expertise unique du marché immobilier du Valais."
  },
  p2: {
    id: "homepage.about.p2",
    defaultMessage:
      "Fondée par Elsje Verfaillie, passionnée par la région et spécialisée dans les chalets, appartements et terrains en Valais, notre agence vous accompagne personnellement et sur mesure dans toutes vos démarches : achat, vente, mise en location, estimation immobilière, construction ou rénovation."
  },
  p3: {
    id: "homepage.about.p3",
    defaultMessage:
      "Notre force réside dans une approche humaine et individualisée, associée à une connaissance approfondie du marché immobilier valaisan. Que ce soit pour une résidence principale, secondaire ou un investissement locatif, nous gérons chaque étape avec rigueur et passion."
  },
  p4: {
    id: "homepage.about.p4",
    defaultMessage:
      "EV Real Estate & Services : l’agence immobilière de confiance pour concrétiser votre projet."
  },
  imageAlt: { id: "homepage.about.image-alt", defaultMessage: "Portrait de l’équipe EV Real Estate & Services" }
});

const AboutPart = ({ className }: { className?: string }) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();
  const wrapperClasses = classNames("about-part", "content", className);

  return (
    <Wrapper.Centered as="section" className={wrapperClasses}>
      <div className="wrap">

        <div className="media">
          <RatioImage source={aboutPath} ratio="1/1" />
        </div>

        <div className="text">
          <span className="sub">{intl.formatMessage(transDefs.kicker)}</span>
          <h2>{intl.formatMessage(transDefs.title)}</h2>
          <p>{intl.formatMessage(transDefs.p1)}</p>
          <p>{intl.formatMessage(transDefs.p2)}</p>
          <p>{intl.formatMessage(transDefs.p3)}</p>
          <p>{intl.formatMessage(transDefs.p4)}</p>
          <Button type="button" className="link"
                  onClick={() => navigate("/agency/")}>
            {intl.formatMessage(actions.more)}
          </Button>
        </div>

      </div>
    </Wrapper.Centered>);
}

export default AboutPart;
